import React from "react";

import ReviewInSet from "./ReviewInSet";

export default function ReviewResultsSet({ reviews }) {
  return (
    <div className={`grid grid-cols-${reviews.length} gap-3 mt-6 mb-16`}>
      {reviews.map((r, i) => (
        <ReviewInSet review={r} key={`ReviewSet${i}`} />
      ))}
    </div>
  );
}
